export default {

    print(etiqueta) {

        const page = window.open('', Math.random())

        let nomeSocial = etiqueta.pacienteNomeSocial ? ` (${etiqueta.pacienteNomeSocial})` : ''

        page.document.write(`
            <head>
                <title>Etiqueta</title>

                <style>
                    * {
                        font-family: 'Arial', 'Arial Bold', Gadget, sans-serif;
                    }
                    .content {
                        align-items: center;
                        display: flex;
                        flex-direction: column;
                        width: 100%;
                    }
                    .paper {
                        width: 10cm;
                        height: 30cm
                    }
                    .container {
                        display: flex;
                        flex-direction: column;
                        padding: 0 0.1cm;
                    }
                    #header {
                        align-items: center;
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                    }
                    #left-col {
                        flex-grow: 1;
                        padding-top:5px;
                    }
                    #right-col {
                        flex-grow: 1;
                        font-size: 0.3cm;
                        text-align: right;
                    }
                    h1 {
                        background-color: #000000;
                        color: #FFFFFF;
                        font-size: 0.25cm;
                        margin: 0;
                        padding: 0.10cm;
                        text-align: center;
                    }
                    p {
                        font-size: 0.25cm;
                        margin: 0.08cm 0;
                        padding: 0;
                    }
                </style>
            </head>

            <body>
                <div class="content">
                    <div class="paper">
                        <h1>${etiqueta.pacienteNome} <span>${nomeSocial}</span></h1>

                        <div class="container">
                            <div id="header">
                                <div id="left-col">
                                    <p>
                                        <strong>IDADE:</strong> ${etiqueta.idade} -
                                        <strong>PRONTUÁRIO:</strong> ${etiqueta.prontuario} -
                                        <strong>NR. AGENDAMENTO:</strong> ${etiqueta.agendamentoNumero}
                                    </p>
                                    <p><strong>UNIDADE:</strong> ${etiqueta.unidade}</p>
                                    <p><strong>LABORATÓRIO:</strong> ${etiqueta.laboratorio}</p>

                                    <p>${etiqueta.sistema.nomeSistema} ${etiqueta.sistema.versao} - ${etiqueta.unidadeLogada}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </body>
        `)

        page.print()
        page.close()
    },
}

